module.exports = __webpack_public_path__ + "img/LeDab Bee Graphic-2.724ba5d7.png";